'use client'

import { HeadlineText } from 'design-configuration/components'
import React from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { trackGenericTabChangedEvent } from 'analytics-utils/src'
import { useQueryState } from 'nuqs'

export const Tabs = ({
  tabs,
  defaultTab,
  className
}: {
  tabs: { [name: string]: React.ReactElement | null }
  defaultTab?: string
  className?: string
}): React.ReactElement => {
  const [activeTab, setActiveTab] = useQueryState('tab', { defaultValue: defaultTab ?? Object.keys(tabs)[0] })

  const setTab = (tabName: string) => {
    setActiveTab(tabName)
    trackGenericTabChangedEvent(tabName)
  }

  return (
    <div className={`flex w-full flex-col items-center justify-center ${className}`}>
      <div className="px-md md:px-2xl gap-x-md md:gap-x-2xl flex w-full">
        {Object.keys(tabs).map((tab) =>
          tabs[tab] ? (
            <button
              key={tab}
              onClick={() => setTab(tab)}
              className={`p-2xs relative flex flex-col justify-center text-center ${
                tab === activeTab ? 'text-on-surface' : 'text-on-surface-variant'
              }`}
            >
              <HeadlineText className="font-medium">{tab}</HeadlineText>
              {tab === activeTab ? (
                <motion.div
                  className="bg-on-surface absolute bottom-0 left-[0px] h-[2px] w-full"
                  layoutId="underline"
                />
              ) : null}
            </button>
          ) : null
        )}
      </div>
      <div className="bg-outline-variant h-[1px] w-full" />
      <AnimatePresence>{tabs[activeTab]}</AnimatePresence>
    </div>
  )
}
